import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SfChevronDownIcon = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    d: "M12.006 18.489c.317 0 .634-.127.849-.367l9.803-10.044a1.13 1.13 0 0 0 .342-.81c0-.66-.494-1.166-1.153-1.166-.316 0-.608.127-.823.33l-9.702 9.916h1.356L2.976 6.431a1.157 1.157 0 0 0-.823-.33C1.493 6.102 1 6.61 1 7.268c0 .317.127.595.342.823l9.803 10.032c.24.24.532.367.861.367Z"
  })
});
export default SfChevronDownIcon;